import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sort-indicator',
  templateUrl: './sort-indicator.component.html',
})
export class SortIndicatorComponent {
  @Input('state') state: string;
}
